import { render, staticRenderFns } from "./PlaylistItem.vue?vue&type=template&id=25ef7562&scoped=true&"
import script from "./PlaylistItem.vue?vue&type=script&lang=js&"
export * from "./PlaylistItem.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistItem.vue?vue&type=style&index=0&id=25ef7562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ef7562",
  null
  
)

export default component.exports